module.exports = __webpack_public_path__ + "static/media/ufo-beam.7428bdb5.svg";